module.exports = __webpack_public_path__ + "static/media/tendercase03.517c9723.png";